import { ProductRepaymentType } from 'domain/Product';
import { Dict } from 'shared/interface/globalInterface';

const repaymentTypeOptionTranslations: Dict = {
  INTEREST_ONLY: 'Interest only',
  CAPITAL_AND_INTEREST: 'Capital and Interest',
};

export const mapRepaymentTypes = (repaymentTypes: ProductRepaymentType[]) =>
  repaymentTypes.map((repaymentType: ProductRepaymentType) => ({
    option: repaymentTypeOptionTranslations[repaymentType],
    value: repaymentType,
  }));
